import { EmbeddableProps } from '@seatsio/seatsio-angular';
import { ChartRendererConfigOptions } from '@seatsio/seatsio-types';
import {
  createInjectionToken,
  createNoopInjectionToken,
} from 'ngxtension/create-injection-token';

export const [, provideSeatsioWorkspaceKey, SEATSIO_WORKSPACE_KEY] =
  createNoopInjectionToken('seats.io workspace key');

export const [, provideSeatsioSecretKey, SEATSIO_SECRET_KEY] =
  createNoopInjectionToken('seats.io secret key');

export const [injectSeatsioConfig, provideSeatsioConfig] = createInjectionToken(
  (workspaceKey: string): EmbeddableProps<ChartRendererConfigOptions> => ({
    workspaceKey,
    region: 'na',
    language: 'es',
    showFullScreenButton: false,
    maxSelectedObjects: 10,
    showMinimap: false,
    fitTo: 'widthAndHeight',
    messages: {
      resale: 'FanClub | Mercado Secundario Fan2Fan',
      feeExcluded: '+ cargos aplicables',
    },
    selectionValidators: [
      {
        type: 'noOrphanSeats',
        mode: 'strict',
      },
    ],
  }),
  {
    deps: [SEATSIO_WORKSPACE_KEY],
  },
);

export const [injectSeatsioManagerConfig, provideSeatsioManagerConfig] =
  createInjectionToken(
    (workspaceKey: string): EmbeddableProps<ChartRendererConfigOptions> => ({
      workspaceKey,
      region: 'na',
      language: 'es',
      showFullScreenButton: false,
    }),
    {
      deps: [SEATSIO_WORKSPACE_KEY],
    },
  );
